import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import StockMainPage from './components/StockMainPage';
import StockDetailPage from './components/StockDetailPage';
import CommunityPage from './components/Community/CommunityPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/stockMain" />} />
      <Route path="/stockMain" element={<StockMainPage />} />
      <Route path="/stockDetail/:stockName" element={<StockDetailPage />} />
      <Route path="/stockCommunity" element={<CommunityPage />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

